<div class="toolbar">
  <button matButton="text" [disabled]="!canSave()" (click)="addWorkingUnit()">
    <span>
      <mat-icon class="size-16">save</mat-icon>
      <label class="buttonLabel">Add Unit</label>
    </span>
  </button>
  <button matButton="text" [disabled]="isBusy()" (click)="clearInputs()">
    <span>
      <mat-icon class="size-16">clear</mat-icon>
      <label class="buttonLabel">Clear Inputs</label>
    </span>
  </button>
  <span class="spacer"></span>
</div>
@if (errorMessage()) {
  <div class="errorMessage">
    {{ errorMessage() }}
  </div>
}
<app-ratings-tool-form [unitToUpdate]="unitToUpdate" (unitToUpdateChange)="updatedUnit = $event"></app-ratings-tool-form>

